<template>
  <v-form @submit.prevent="checkIfRecaptchaVerified" ref="formForgotPassword" lazy-validation v-model="validForm">
    <v-card-text class="pb-0">
      <h4 class="primary--text text-center mb-5">Digite o usuário ou e-mail para solicitar a redefinição de senha.</h4>

      <v-text-field
        clearable
        append-icon="person"
        name="email"
        label="Usuário ou Email"
        type="text"
        v-model="email"
        required
        :rules="emailRules"
        @click:clear="clear"
      ></v-text-field>
    </v-card-text>

    <v-card-actions class="justify-center" v-if="recaptcha.visible">
      <vue-recaptcha ref="recaptcha" @verify="markRecaptchaAsVerified" :sitekey="recaptcha.sitekey" :loadRecaptchaScript="true"></vue-recaptcha>
    </v-card-actions>

    <v-card-actions class="password--buttons">
      <v-btn outlined color="primary" @click="toLogin"> <v-icon right>keyboard_backspace</v-icon>Login </v-btn>
      <v-btn type="submit" color="primary" :disabled="!validForm">
        Redefinir Senha
        <v-icon left>arrow_right_alt</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { sendEmailForgotPassword } from '@/services/authentication';
import store from '@/store';

export default {
  components: {
    VueRecaptcha: () => import('vue-recaptcha')
  },

  props: {
    recaptcha: {
      type: Object
    }
  },

  data: () => ({
    recaptchaVerified: false,
    validForm: true,
    email: '',
    emailRules: [v => !!v || 'Campo obrigatório']
  }),

  methods: {
    markRecaptchaAsVerified(response) {
      this.recaptchaVerified = true;
    },

    checkIfRecaptchaVerified() {
      if (this.recaptcha.visible) {
        if (!this.recaptchaVerified) {
          store.dispatch('notification/showNotification', {
            color: 'error',
            text: 'Falha na validação do CAPTCHA. Verifique!',
            showIconNotification: false
          });

          return true;
        }
      }

      this.handleForgotPassword();
    },

    async handleForgotPassword() {
      if (!this.$refs.formForgotPassword.validate(true)) return;

      try {
        const { data, status } = await sendEmailForgotPassword(this.email);

        status === 200 &&
          store.dispatch('notification/showNotification', {
            color: 'success',
            text: data,
            showIconNotification: false
          });
      } catch (err) {
        store.dispatch('notification/showNotification', {
          color: 'error',
          text: err,
          showIconNotification: false
        });
      }
    },

    toLogin() {
      this.recaptchaVerified = false;
      this.$refs.formForgotPassword.reset();
      this.$emit('changeForm');
    },

    clear() {
      this.$nextTick(() => (this.email = ''));
    }
  }
};
</script>
